var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"alert-danger",attrs:{"show":_vm.show,"variant":"danger","dismissible":""},on:{"dismissed":function($event){_vm.errosTemp=[]}}},[_c('h5',[_vm._v("Erro(s):")]),_c('ul',_vm._l((_vm.errosTemp),function(erro){return _c('li',{key:erro},[_vm._v(_vm._s(erro))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }